'use client'

import './ProductCard.scss'
import 'animate.css'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { styled, Typography } from '@material-ui/core'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React from 'react'
import { excludeArticleDiscount } from '../../../shared/constants/discount'

export function ProductCardSpecial({ price, specials = false, sku, name }) {
    const { userAuth, userInfo } = useGetIsAuthUser()

    const userGroup = userAuth ? Number(userInfo.customerGroupId) : 0

    let special = null

    const specialsData = Object.values(specials)

    for (let index = 0; index < specialsData.length; index++) {
        const element = specialsData[index]
        const groupId = Number(element.customer_group_id)
        if (
            (groupId === 1 && userGroup !== 2) ||
            (groupId === 2 && userGroup === 2)
        ) {
            special = element
        }
    }

    return (
        <div className={'priceContainer'}>
            {!special && (
                <h4 className={'price'}>
                    {Math.round(parseInt(price))} ₽
                </h4>
            )}
            {special && (
                <>
                    <span className={'special price'}>
                        {Math.round(parseInt(special.price))} ₽
                    </span>
                    <h4 className={'price lineThrow'}>
                        {Math.round(parseInt(price))} ₽
                    </h4>
                </>
            )}
        </div>
    )
}

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow placement="top-start" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '4px',
    fontFamily: 'inherit',
    boxShadow: theme.shadows[4],
    minWidth: 220,
    maxWidth: 260,
    textAlign: 'left',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000',
    marginLeft: '18px', // смещение стрелки влево
  },
}));